import type { IBlog } from "../types/general";
import { ref } from "vue";

export default function useBlog() {
  const blogs = ref<{ attributes: IBlog; id: number }[]>([]);
  const post = ref<{ attributes: IBlog; id: number }>();
  const currentPage = ref(1);
  const lastPage = ref(1);
  const perPage = 10;

  const fetchBlog = async (page = 1) => {
    const { data, fetchData } = useCustomFetch<
      { attributes: IBlog; id: number }[]
    >(`/api/blog/posts?page=${page}&per_page=${perPage}`);
    await fetchData();
    if (data.value?.data) {
      blogs.value =
        page === 1
          ? data.value.data
          : [...blogs.value, ...data.value.data];
    }
    currentPage.value = data.value?.meta?.current_page ?? page;
    lastPage.value = data.value?.meta?.last_page ?? 1;
  };

  const fetchPost = async (slug: string): Promise<void> => {
    const { data, fetchData } = useCustomFetch<{
      attributes: IBlog;
      id: number;
    }>(`/api/blog/posts/${slug}`);
    await fetchData();
    if (data.value?.data) post.value = data.value?.data;
  };

  return {
    fetchBlog,
    fetchPost,
    blogs,
    post,
    currentPage,
    lastPage,
  };
}
